/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: {
    currentUser?: {
      globalRole?: string;
    };
  } | undefined,
) {
  const globalRole = initialState?.currentUser?.globalRole ?? null;
  const isManager = globalRole === 'ADMIN' || globalRole === 'SUPER_ADMIN';

  return {
    canManage: isManager,
    isStandardUser: globalRole === 'USER',
  };
}
